import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { AnchorNav as AnchorNavStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'
import { CommonProps } from '../helperTypes'

const useStyles = createUseStyles(AnchorNavStyles, 'anchornav')

const AnchorNavList = ({ children, className, ...rest }: PropsWithChildren<CommonProps>) => {
  const classes = useStyles()
  return (
    <ul className={clsx(className, classes.list)} aria-hidden='false' {...rest}>
      {children}
    </ul>
  )
}

export default AnchorNavList
